export default __webpack_public_path__ + "static/media/Copperplate-Light.269101cb.ttf";